import { render, staticRenderFns } from "./BedReport.vue?vue&type=template&id=11e87531&scoped=true&"
import script from "./BedReport.vue?vue&type=script&lang=js&"
export * from "./BedReport.vue?vue&type=script&lang=js&"
import style0 from "./BedReport.vue?vue&type=style&index=0&id=11e87531&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e87531",
  null
  
)

export default component.exports